export default {
  path: 'planning',
  name: 'planning',
  component: () => import(/* webpackChunkName: "Planning" */'@views/planning/Index'),
  meta: {
    title: 'data.menu.planning.title',
  }
}
